import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="portal-footer">
      <p>&copy; 2024 Hahum.com. v0.99 All rights reserved.</p>
    </footer>
  );
};

export default Footer;